import { useTranslation } from 'react-i18next';

import { Box } from '@base-app';
import { COMMON_TRANSLATION, DEFAULT_HEIGHT, DEFAULT_WIDTH } from '@common/constants';

import useUSMapChoropleth from './useUSMapChoropleth';
import MapChoropleth from '../MapChoropleth/MapChoropleth';
import { USMapChoroplethProps } from './USMapChoropleth.types';
import { FC } from 'react';
import PopupCountyInfo from '../PopupCountyInfo/PopupCountyInfo';
import { HighlightedFeature } from '../MapChoropleth/MapChoropleth.types';

const USMapChoropleth: FC<USMapChoroplethProps<HighlightedFeature>> = ({
  buildPopupInfo,
  zctas,
  height = DEFAULT_HEIGHT,
  width = DEFAULT_WIDTH,
}) => {
  const { t } = useTranslation(COMMON_TRANSLATION);
  const { featuresList, bounds } = useUSMapChoropleth({ zctas });

  return (
    <Box
      css={{
        margin: 'auto',
        width,
        height,
      }}
    >
      {!!featuresList?.length && !!bounds && (
        <MapChoropleth
          bounds={bounds}
          featuresList={featuresList}
          height={height}
          renderPopup={(data) => <PopupCountyInfo info={buildPopupInfo(data)} />}
          legend={{
            height: '400px',
            labelBottom: t('map.choropleth.low_density'),
            labelTop: t('map.choropleth.high_density'),
          }}
          width={width}
        />
      )}
    </Box>
  );
};

export default USMapChoropleth;
